// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "code/chunk-" + {"64":"subapps/onboarding","266":"subapps/kb","757":"subapps/chat","825":"subapps/settings"}[chunkId] + "." + {"64":"e973e0a5062fb8320f5f","266":"360d5fb65f660ebc722f","757":"f4bcf959d3cd4317aed4","825":"e5504bcaf233caad18e9"}[chunkId] + ".css";
};